import React from "react";
import { Moment } from "moment";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  dateToMoment,
  momentToDate,
  momentToTime,
  timeToMoment,
} from "./helpers";

// Both fields assume they are rendered inside a <LocalizationProvider adapter={AdapterMoment}>.

interface TimeFieldProps {
  value: string; // "HH:mm"
  onChange: (time: string) => void;
  disabled?: boolean;
  minWidth?: number;
}

export const TimeField: React.FC<TimeFieldProps> = ({
  value,
  onChange,
  disabled = false,
  minWidth = 130,
}) => (
  <DesktopTimePicker
    value={timeToMoment(value)}
    onChange={(m) => onChange(momentToTime(m as Moment | null))}
    disabled={disabled}
    ampm
    slotProps={{ textField: { size: "small", sx: { minWidth } } }}
  />
);

interface DateFieldProps {
  value: string; // ISO "YYYY-MM-DD"
  onChange: (date: string) => void;
  disabled?: boolean;
  minDate?: string;
  maxDate?: string;
  fullWidth?: boolean;
}

export const DateField: React.FC<DateFieldProps> = ({
  value,
  onChange,
  disabled = false,
  minDate,
  maxDate,
  fullWidth = true,
}) => (
  <DatePicker
    value={dateToMoment(value)}
    onChange={(m) => onChange(momentToDate(m as Moment | null))}
    disabled={disabled}
    minDate={minDate ? (dateToMoment(minDate) ?? undefined) : undefined}
    maxDate={maxDate ? (dateToMoment(maxDate) ?? undefined) : undefined}
    format="MMM D, YYYY (ddd)"
    slotProps={{ textField: { size: "small", fullWidth } }}
  />
);
